/**
 * Vuex plugin
 *
 * @param {array} mutations - array with string mutation type names
 * @returns {Function}
 */

import deepClone from '@/common/helpers/deep-clone';

// we shouldn't unregister modules loading and route to avoid navigation problems
// that modules stored actual component loading states and navigation
const unremovableModules = ['loading', 'route'];

export const resetStorePlugin = mutations => (store) => {
    // copy of the initial store
    // this is the copy of the store before any action and plugin calls
    // so this is the state that defined in the stores by default
    const init = deepClone(store.state);

    // the reset mutation names object
    // {mutation-string-type-name: true}
    // we use the object instead of the array,
    // to increase the mutation name check speed
    const resetMutationNamesCache = mutations.reduce((memo, name) => ({
        ...memo,
        [name]: true,
    }), {});

    store.subscribe((mutation) => {
        if (resetMutationNamesCache[mutation.type]) {
            setTimeout(() => {
                store.commit('resetStoreMutation', {
                    state: {
                        ...init,
                    },
                    unregisterModule: name => store.unregisterModule(name),
                });
            }, 1);
        }
    });
};

/**
 * Vuex root mutation to replace each store in each module
 *
 * @param state
 * @param initialState - initial state object copy
 * @param unregisterModule - the store.unregisterModule method, to unregister the new modules
 */
export const resetStoreMutation = (state, {state: initialState, unregisterModule}) => {
    const initialModules = Object.keys(initialState);
    const activeModules = Object.keys(state);

    // right now we will have empty array here every time
    const removalModules = activeModules
        .filter(name => !initialModules.includes(name) && !unremovableModules.includes(name));

    removalModules.forEach((name) => {
        unregisterModule(name);
    });

    initialModules.forEach((key) => {
        state[key] = initialState[key];
    });
};
